import { render, staticRenderFns } from "./CompanyBasicInfoForm.vue?vue&type=template&id=308b70b8&"
import script from "./CompanyBasicInfoForm.vue?vue&type=script&lang=js&"
export * from "./CompanyBasicInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CompanyBasicInfoForm.vue"
export default component.exports